import { api } from "@/lib/api";

export const CATEGORY_OPTIONS = [
  ["referral", "Referral"],
  ["imaging", "Imaging"],
  ["pathology", "Pathology"],
  ["specialist_report", "Specialist report"],
  ["gp_correspondence", "GP correspondence"],
  ["insurance", "Insurance"],
  ["ndis", "NDIS"],
  ["workcover", "WorkCover"],
  ["consent", "Consent"],
  ["exercise_program", "Exercise program"],
  ["other", "Other"],
];

export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024;
export const LARGE_PREVIEW_BYTES = 10 * 1024 * 1024;

// First match wins; whole-word tests on the file name (staff can change the pick).
const CATEGORY_HINTS = [
  ["imaging", /\b(us|ultrasound|mri|x[\s-]?ray|xr|ct|scan|dexa|imaging|radiology|i[\s-]?med)\b/i],
  ["referral", /\b(referral|refer|ref)\b/i],
  ["pathology", /\b(pathology|blood|bloods|path|lab|results?)\b/i],
  ["specialist_report", /\b(specialist|surgeon|neurolog\w*|oncolog\w*|orthop\w*|cardiolog\w*|report)\b/i],
  ["gp_correspondence", /\b(gp|letter|correspondence)\b/i],
  ["ndis", /\bndis\b/i],
  ["workcover", /\b(workcover|worksafe|icare)\b/i],
  ["insurance", /\b(insurance|insurer|tac|claim)\b/i],
  ["consent", /\bconsent\b/i],
  ["exercise_program", /\b(program|programme|exercises?|hep)\b/i],
];

export function suggestCategory(filename) {
  const words = (filename || "").replace(/\.[^.]+$/, "").replace(/[_\-.]+/g, " ");
  return (CATEGORY_HINTS.find(([, rx]) => rx.test(words)) || ["other"])[0];
}

export const categoryLabel = (k) => (CATEGORY_OPTIONS.find(([v]) => v === k) || [null, "Other"])[1];

export function fmtDate(v) {
  if (!v) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(v));
  const d = m ? new Date(+m[1], +m[2] - 1, +m[3]) : new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleDateString("en-AU", { day: "2-digit", month: "short", year: "numeric" });
}

export function fmtSize(bytes) {
  if (!bytes) return "";
  return bytes >= 1024 * 1024 ? `${(bytes / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`;
}

export function previewKind(f) {
  const ct = (f?.content_type || "").toLowerCase();
  const name = (f?.filename || "").toLowerCase();
  if (ct.includes("pdf") || name.endsWith(".pdf")) return "pdf";
  if (ct.startsWith("image/")) return "image";
  if (ct.startsWith("text/") || /\.(txt|csv)$/.test(name)) return "text";
  return null;
}

export async function fetchFileBlob(f) {
  const r = await api.get(`/health-record/attachments/${f.id}/download`, { responseType: "blob" });
  return new Blob([r.data], { type: f.content_type || r.data.type || "application/octet-stream" });
}

export async function downloadFile(f) {
  const url = URL.createObjectURL(await fetchFileBlob(f));
  const a = document.createElement("a");
  a.href = url;
  a.download = f.filename || "attachment";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
